import React from 'react';
import { Box, Container, Typography, IconButton, Link, Grid } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import FacebookIcon from '@mui/icons-material/Facebook';
import EmailIcon from '@mui/icons-material/Email';

function Footer() {
  // --- AUTOMATIC YEAR VARIABLE ---
  const currentYear = new Date().getFullYear();
  // -------------------------------

  return (
    <Box component="footer" sx={{ bgcolor: 'primary.main', color: 'white', py: 6, mt: 'auto' }}>
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          
          {/* Column 1: Brand & Social */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Christmas Lights Map {currentYear}
            </Typography>
            <Typography variant="body2" sx={{ opacity: 0.8, mb: 2 }}>
              Your guide to the best festive displays across Australia.
            </Typography>
            
            {/* SOCIAL ICONS */}
            <Box>
              <IconButton 
                component="a" 
                href="https://www.facebook.com/profile.php?id=61585180973488" 
                target="_blank" 
                rel="noopener noreferrer"
                sx={{ color: 'white', mr: 1, border: '1px solid rgba(255,255,255,0.3)' }}
              >
                <FacebookIcon />
              </IconButton>
              <IconButton 
                component={RouterLink} 
                to="/contact" 
                sx={{ color: 'white', border: '1px solid rgba(255,255,255,0.3)' }}
              >
                <EmailIcon />
              </IconButton>
            </Box>
          </Grid>

          {/* Column 2: Quick Links */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Quick Links
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/" color="inherit" underline="hover">Home Map</Link>
              <Link component={RouterLink} to="/blog" color="inherit" underline="hover">Blog & Guides</Link>
              <Link component={RouterLink} to="/add" color="inherit" underline="hover">Add Display</Link>
              <Link component={RouterLink} to="/dashboard" color="inherit" underline="hover">Search Dashboard</Link>
            </Box>
          </Grid>

          {/* Column 3: Legal */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" gutterBottom sx={{ fontWeight: 'bold' }}>
              Legal & Info
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link component={RouterLink} to="/privacy" color="inherit" underline="hover">Privacy Policy</Link>
              <Link component={RouterLink} to="/about" color="inherit" underline="hover">About Us</Link>
              <Link component={RouterLink} to="/contact" color="inherit" underline="hover">Contact</Link>
            </Box>
          </Grid>
        </Grid>

        {/* COPYRIGHT & ABN SECTION */}
        <Box sx={{ mt: 5, borderTop: '1px solid rgba(255,255,255,0.2)', pt: 3, textAlign: 'center' }}>
          <Typography variant="body2" sx={{ opacity: 0.7 }}>
            {'© '} 
            {currentYear} 
            {' TermPlanner. Christmas Lights Map Australia. All rights reserved.'}
          </Typography>
          
          {/* ABN LINE (Add your number here) */}
          <Typography variant="caption" sx={{ opacity: 0.5, display: 'block', mt: 0.5 }}>
            ABN: 24 220 795 019
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;